export const streetTypeAbbreviations: Record<string, string> = {
    'Street': 'St', 'Road': 'Rd', 'Avenue': 'Ave', 'Drive': 'Dr',
    'Lane': 'Ln', 'Crescent': 'Cres', 'Terrace': 'Tce', 'Parade': 'Pde',
    'Place': 'Pl', 'Court': 'Ct', 'Close': 'Cl', 'Circuit': 'Cct',
    'Grove': 'Grv', 'Way': 'Way', 'Boulevard': 'Blvd', 'Plaza': 'Plz',
    'Square': 'Sq', 'Highway': 'Hwy', 'Esplanade': 'Esp', 'Rise': 'Rise',
    'Track': 'Trk', 'Walk': 'Wlk', 'Mews': 'Mews'
};

export const abbreviateStreetType = (streetWithType: string): string => {
    let result = streetWithType;
    for (const [full, abbr] of Object.entries(streetTypeAbbreviations)) {
        result = result.replace(new RegExp(`\\b${full}\\b`, 'i'), abbr);
    }
    return result;
};

/**
 * Generate project folder/file name: "Suburb - Street St - Unit Job (MMYY)"
 */
export const generateProjectName = (formDataInput?: any): string => {
    const now = new Date();
    const monthYear = String(now.getMonth() + 1).padStart(2, '0') + String(now.getFullYear()).slice(-2);

    const address = formDataInput?.address || '';
    const unitNumber = formDataInput?.unitNumber || '';
    const jobDescription = formDataInput?.jobDescription || '';

    let suburb = '';
    let streetName = '';

    if (address.trim()) {
        const streetTypes = ['Esplanade', 'Boulevard', 'Crescent', 'Terrace', 'Highway', 'Circuit', 'Parade', 'Avenue', 'Street', 'Square', 'Close', 'Grove', 'Place', 'Court', 'Drive', 'Plaza', 'Track', 'Walk', 'Mews', 'Rise', 'Road', 'Lane', 'Blvd', 'Cres', 'Cct', 'Pde', 'Ave', 'Tce', 'Hwy', 'Esp', 'Grv', 'Plz', 'Trk', 'Wlk', 'Way', 'Sq', 'St', 'Rd', 'Dr', 'Ln', 'Pl', 'Ct'];

        const parts = address.split(/[,–\-\n]/).map((p: string) => p.trim()).filter((p: string) => Boolean(p));

        if (parts.length >= 2) {
            const streetPart = parts[0];

            const stateNames = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT', 'ACT', 'New South Wales', 'Victoria', 'Queensland', 'South Australia', 'Western Australia', 'Tasmania', 'Northern Territory', 'Australian Capital Territory'];
            for (let i = 1; i < parts.length; i++) {
                const part = parts[i].trim();
                if (/^\d{4}$/.test(part)) continue;
                if (stateNames.some(s => s.toLowerCase() === part.toLowerCase())) continue;
                if (/^(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\s+\d{0,4}/i.test(part)) continue;
                suburb = part.replace(/\s+(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\s*\d{0,4}\s*$/i, '').replace(/\s+\d{4}\s*$/, '').trim();
                break;
            }

            const streetWords = streetPart.split(/\s+/);
            const startIdx = /\d/.test(streetWords[0]) ? 1 : 0;
            streetName = streetWords.slice(startIdx).join(' ');
        } else {
            const words = address.split(/\s+/).filter((w: string) => Boolean(w));
            if (words.length >= 4) {
                let typeIndex = -1;
                for (let i = 1; i < words.length; i++) {
                    if (streetTypes.some(type => new RegExp(`^${type}$`, 'i').test(words[i]))) {
                        typeIndex = i;
                        break;
                    }
                }

                if (typeIndex > 0) {
                    streetName = words.slice(1, typeIndex + 1).join(' ');
                    let suburbWords: string[] = [];
                    for (let i = typeIndex + 1; i < words.length; i++) {
                        if (/^(NSW|VIC|QLD|SA|WA|TAS|NT|ACT|\d{4})$/i.test(words[i])) break;
                        suburbWords.push(words[i]);
                    }
                    suburb = suburbWords.join(' ');
                } else {
                    streetName = words.slice(1, 3).join(' ');
                    for (let i = words.length - 1; i >= 3; i--) {
                        if (!/^(NSW|VIC|QLD|SA|WA|TAS|NT|ACT|\d{4})$/i.test(words[i])) {
                            suburb = words[i];
                            break;
                        }
                    }
                }
            }
        }
    }

    let nameParts: string[] = [];
    if (suburb) nameParts.push(suburb);
    if (streetName) nameParts.push(abbreviateStreetType(streetName));

    let jobPart = '';
    if (unitNumber) jobPart += unitNumber.trim();
    if (jobDescription) jobPart += (jobPart ? ' ' : '') + jobDescription.trim();
    if (jobPart) nameParts.push(jobPart);

    nameParts.push(`(${monthYear})`);

    let projectName = nameParts.join(' - ')
        .replace(/[<>:"/\\|?*]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    if (!projectName || projectName === `(${monthYear})`) {
        projectName = `Quote (${monthYear})`;
    }

    return projectName;
};

/**
 * Generate subfolder name from form data
 */
export const generateSubfolderName = (formDataInput?: any): string => {
    return generateProjectName(formDataInput);
};
